import graphql__49bb57260d3e5451160d from "./__generated__/ContributionsList_participativeModule.graphql.js";import { graphql } from "react-relay";

import ListContribution from "./ListContribution";
import InfinitelyScrollableContainer from "../../Utils/InfinitelyScrollableContainer";
import useFilterableContributionsList from "./useFilterableContributionsList";
import { ContributionsListWithNavigationFragment_participativeModule } from "./ContributionsListWithNavigationFragment";
import { BoxSpinner } from "../../Utils/Spinner";
import ModalOutlet from "../../Routing/ModalOutlet";

export const CONTRIBUTIONS_BATCH_SIZE = 10;

const ContributionsList = ({ hasNavigation = false, ...props }) => {
  const fragment = hasNavigation
    ? ContributionsListWithNavigationFragment_participativeModule
    : ContributionsList_participativeModule;

  const { contributions, isLoading, loadMore, isLoadingNext, emptyListMessage } =
    useFilterableContributionsList({
      contribuable: props.participativeModule,
      fragment,
      contributionsBatchSize: CONTRIBUTIONS_BATCH_SIZE
    });

  return (
    <div className="contributions-list position-relative">
      <InfinitelyScrollableContainer className="boxes-list" onBottomReached={loadMore}>
        {contributions.map(contribution => (
          <ListContribution key={contribution.id} contribution={contribution} />
        ))}

        {/* Message displayed when there's no contribution, with a specific
            message, whether there is no contribution published, or if the
            filtered list has no results */}
        {emptyListMessage && <div className="box padding-md">{emptyListMessage}</div>}

        {/* Overlay displayed on top of contributions while the contributions
            list is reloaded, after the filters are updated */}
        {isLoading && <div className="container-overlay" />}

        {isLoadingNext && <BoxSpinner />}
      </InfinitelyScrollableContainer>

      <ModalOutlet />
    </div>
  );
};

// This fragment is used by several components to centralize the refetching of the right
// data whatever the parent component is.
export const ContributionsList_participativeModule = graphql__49bb57260d3e5451160d;

export default ContributionsList;
